<ng-container *appCalendarAppContext>
<!--
  #998 iteration 2: calendar has no top bar. The page starts at y = 0, so this wrapper is calendar's
  own — `.under-nav-bar` is shared by the three layouts that still carry a 48 px `app-nav-bar`
  (contacts, notes, files) plus the three `app-base-nav-bar` ones, and must keep its offset for them.
  (tasking left that list in iteration 3.)

  #1547: the rail's OWN split-view is gone, as notes' went in #1146 and mail's in round 1. It is a fixed
  266 px column now — no gutter, no drag, no magnetic width and no reopen chevron. The rail component
  owns its parked width; the host owns the docked one and passes it in the stylesheet.

  The EVENTS LIST keeps its splitter, and keeps `[iconTop]="38"` with it, as `mail-layout`,
  `tasking-layout` and `layout.component.html` do: the reopen chevron's stylesheet default is
  `top: -10px` measured from the split-view's own top edge, which from y = 0 would draw half above the
  window.
-->
<div class="events-shell">
  <!--
    The shell sits OUTSIDE `*stchSpaceRerender` on purpose: the bell's subscription, the app switcher
    and the search input survive a workspace switch. Only the rail below is torn down and rebuilt.
    Calendar's projected child is `SidebarTeamsComponent` rather than a bare `app-<x>-side-bar`.
  -->
  <app-collapsible-rail-shell class="events-rail" [app]="app">
    <stch-side-bar-teams
      *stchSpaceRerender
      [template]="sidebarTemplate"
      [splitViewKey]="sidebarSplitViewKey.calendar"
    />
  </app-collapsible-rail-shell>

  <!-- The rest of the row is the provider itself: it provides the list's and the main view's stores. -->
  <stch-date-range-calendar-events-store-provider class="events-rest">
    <app-split-view
      side="left"
      key="eventsList"
      [collapsedSize]="25"
      [shadow]="true"
      [magneticSize]="260"
      [withIcon]="true"
      [iconTop]="38"
    >
      <app-events-list-container
        #eventsListContainer
        split-left-pane
        *stchSpaceRerender
        class="list shadow-lg"
      />

      <div class="full-form shadow-lg" split-right-pane>
        <stch-calendar-app-main-view *stchSpaceRerender />
      </div>
    </app-split-view>
  </stch-date-range-calendar-events-store-provider>

  <ng-template #sidebarTemplate let-team="team">
    <app-events-side-bar [team]="team"/>
  </ng-template>

</div>
</ng-container>
